import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonButton, IonIcon, IonItemOption } from "@ionic/vue";

import { ION_VARIANT } from "@/types/enum/ionicEnum";

export default /*@__PURE__*/_defineComponent({
  __name: 'SliderOptionDeleteBoxed',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItemOption), {
    color: _unref(ION_VARIANT).LIGHT,
    class: "max-height"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonButton), {
        color: _unref(ION_VARIANT).CORAL,
        class: "max-size box-button"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonIcon), {
            icon: "assets/icon/delete.svg",
            class: "light-light-color",
            style: {"height":"100%"}
          })
        ]),
        _: 1
      }, 8, ["color"])
    ]),
    _: 1
  }, 8, ["color"]))
}
}

})